import DividerShapeSVG from '../../Icons/HomePage/shape-1.svg'

function DividerShape() {
    return (
        <div className="m-auto max-w-full w-[900px] mt-12 md:px-0 text-center md:-mb-16 -mb-10">
            <DividerShapeSVG className="mx-auto -mt-[5rem] max-w-full" />
        </div>
    )
}

export default DividerShape
